var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
var locals_ = (locals || {}),record = locals_.record,schema = locals_.schema,value = locals_.value,time = locals_.time;
var jade_indent = [];
buf.push("\n<tr" + (jade.attr("id", "record-id-" + (record.id) + "", true, false)) + " class=\"record-row\">");
// iterate schema.properties 
;(function(){
  var $$obj = schema.properties ;
  if ('number' == typeof $$obj.length) {

    for (var name = 0, $$l = $$obj.length; name < $$l; name++) {
      var property = $$obj[name];

value = record.properties[name]
buf.push("\n  <td" + (jade.cls(["type-" + (property.type == '[Function]' ? 'function' : property.type) + ""], [true])) + "><span" + (jade.attr("data-title", "" + (name) + "", true, false)) + (jade.attr("data-content", "" + (value) + "", true, false)) + " class=\"record-value\">");
if (property.type == 'timestamp')
{
if (value && value.toString().length == 10) value = value * 1000
time = value ? this.moment(value).format("YYYY-MM-DD HH:mm:ss ZZ") : ''
buf.push("" + (jade.escape((jade_interp = time) == null ? '' : jade_interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade_interp = value) == null ? '' : jade_interp)) + "");
}
buf.push("</span></td>");
    }

  } else {
    var $$l = 0;
    for (var name in $$obj) {
      $$l++;      var property = $$obj[name];

value = record.properties[name]
buf.push("\n  <td" + (jade.cls(["type-" + (property.type == '[Function]' ? 'function' : property.type) + ""], [true])) + "><span" + (jade.attr("data-title", "" + (name) + "", true, false)) + (jade.attr("data-content", "" + (value) + "", true, false)) + " class=\"record-value\">");
if (property.type == 'timestamp')
{
if (value && value.toString().length == 10) value = value * 1000
time = value ? this.moment(value).format("YYYY-MM-DD HH:mm:ss ZZ") : ''
buf.push("" + (jade.escape((jade_interp = time) == null ? '' : jade_interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade_interp = value) == null ? '' : jade_interp)) + "");
}
buf.push("</span></td>");
    }

  }
}).call(this);

buf.push("\n</tr>");;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}